import React from "react";

const reasons = [
  "Question is wrong",
  "Answer options are wrong",
  "Right option is marked as wrong",
  "Poorly formatted question",
  "Poorly formatted options",
  "Image is not displayed properly",
  "Other, please specify",
];

const FlagModal = ({
  visible,
  onClose,
  onSubmit,
  selectedReason,
  setSelectedReason,
  questionId,
  otherText,
  setOtherText,
}) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white w-full max-w-md p-6 rounded-xl shadow-lg relative">
        <h2 className="text-xl font-semibold mb-4">
          Why are you flagging this question?
        </h2>
        <div className="space-y-3">
          {reasons.map((reason, idx) => (
            <label
              key={idx}
              className="flex items-start space-x-2 cursor-pointer"
            >
              <input
                type="radio"
                name="flag-reason"
                value={reason}
                checked={selectedReason === reason}
                onChange={() => setSelectedReason(reason)}
                className="mt-1 accent-purple-600"
              />
              <span className="text-sm">{reason}</span>
            </label>
          ))}
        </div>
        {selectedReason === "Other, please specify" && (
          <div className="mt-4">
            <input
              type="text"
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Please explain"
              value={otherText}
              onChange={(e) => setOtherText(e.target.value)}
            />
          </div>
        )}
        <div className="flex justify-end space-x-3 mt-6">
          <button
            className="px-4 py-2 text-sm rounded bg-gray-200 hover:bg-gray-300"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            disabled={
              !selectedReason ||
              (selectedReason === "Other, please specify" && !otherText)
            }
            className={`px-4 py-2 text-sm rounded text-white ${
              selectedReason &&
              (selectedReason !== "Other, please specify" || otherText)
                ? "bg-purple-600 hover:bg-purple-700"
                : "bg-purple-300"
            }`}
            onClick={onSubmit}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default FlagModal;
